/* eslint-disable max-len */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */

import React, { useEffect, useState, useRef, useContext } from 'react';
import { useLazyQuery, NetworkStatus } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';

import { Box, TablePagination } from '@mui/material';
import moment from 'moment';

import { setSelectedAlertType, setSelectedDateRangePicker } from '../../../../../store/actions/Alerts/action';

import TeamAlertsGrid from '../Grid/TeamAlertsGrid';
import Search from '../Search/Search';
import Filters from './Filters/Filters';

import * as Q from '../../../../../constants/graphqlQueries';
import { TODAY, THIS_WEEK, CUSTOM } from '../../../../../constants/dateRanges';
import { MY_TEAM, OTHER_TEAMS } from '../../../../../constants/teamNames';
import transactionResponse from '../../../../../constants/transactionResponse';
import AlertType from '../../../../../constants/alertType';
import showRefreshNotification from './RefreshNotification/RefreshNotification';
import SwitchCustom from '../../../../Switch/SwitchCustom';
import { TeamAlertsContext, TeamAlertsContextProvider } from '../../../../../context/team-alerts-context';
import * as TeamAlertsConstants from '../utils/constants'
import ColumnFilter from './TooltipFilter/ColumnFilter';
import CalloutBasic from '../../../../Callout/Callout';

import '../../TeamAlerts.css';
import 'react-toastify/dist/ReactToastify.css';

const TeamAlertsSearch = () => {
  // Context
  const { gridFilterOptions, setGridFilterOptions } = useContext(TeamAlertsContext);

  const user = useSelector((state) => state.User);

  const selectedAlertType = useSelector((state) => state.Alerts.selectedAlert);
  const employeeId = useSelector((state) => state.User.EmployeeId);
  const selectedDateRangePicker = useSelector((state) => state.Alerts.selectedDateRangePicker);
  const selectedTeamName = useSelector((state) => state.Alerts.selectedTeamName);
  const selectedDateRange = useSelector((state) => state.Alerts.selectedDateRange);
  const dispatch = useDispatch();

  const toastId = useRef(null);
  const [selectedCPPS, setSelectedCPPS] = useState({ client: null, program: null, project: null, site: null, agentEmployeeId: null, agentEmployeeName: null, supervisorEmployeeId: null });
  const [latestTimeoutId, setLatestTimeoutId] = useState(null);

  const [gridTitle, setGridTitle] = useState(TeamAlertsConstants.gridTitles.Alerts);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([selectedTeamName, selectedDateRange]);
  const [alertType, setAlertType] = useState(false);

  const [lastKey, setLastKey] = useState(0);
  const [nextPage, setNextPage] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const clearAutoRefresh = () => {
    toast.dismiss(toastId.current);
    clearTimeout(latestTimeoutId);
    setLatestTimeoutId(null);
    toastId.current = null;
  }
  const clearPagination = () => {
    setLastKey(0);
    setNextPage(true);
    setTotalPages(0);
    setCurrentPage(0);
  }

  const filterDataByFilterType = (filterType, source) => {
    let updatedData = source;

    if (gridFilterOptions[filterType].options.length) {
      const alertTypesToFilter = gridFilterOptions[filterType].options.filter(option => option.isActive === true).map(option => option.title);
      const dataFieldName = TeamAlertsConstants.filterHeaderToFieldMapping[filterType];

      if (alertTypesToFilter.length) {
        updatedData = updatedData.filter(alert => alertTypesToFilter.includes(alert[dataFieldName]))
          .sort((a, b) => a[dataFieldName].localeCompare(b[dataFieldName], 'en'));
      }

      if (!(gridFilterOptions[filterType].ascendingSortOrder)) {
        updatedData = updatedData.reverse();
      }
    }

    return updatedData;
  }

  useEffect(() => {
    if (gridFilterOptions && data) {
      let dataSorted = data.map(item => ({ ...item }));

      if (gridFilterOptions[TeamAlertsConstants.gridFilterTypes.AlertType].ascendingSortOrder !== null) {
        const dataFieldName = TeamAlertsConstants.filterHeaderToFieldMapping[TeamAlertsConstants.gridFilterTypes.AlertType];
        dataSorted = data.map(item => ({ ...item })).sort((a, b) => a[dataFieldName].localeCompare(b[dataFieldName], 'en'));

        if (!(gridFilterOptions[TeamAlertsConstants.gridFilterTypes.AlertType].ascendingSortOrder)) {
          dataSorted = dataSorted.reverse();
        }
      }

      setData(dataSorted);
    }
  }, [gridFilterOptions[TeamAlertsConstants.gridFilterTypes.AlertType].ascendingSortOrder]);
  useEffect(() => {
    if (gridFilterOptions[TeamAlertsConstants.gridFilterTypes.Agent].ascendingSortOrder !== null) {
      let dataSorted = data.map(item => ({ ...item }));
      const dataFieldName = TeamAlertsConstants.filterHeaderToFieldMapping[TeamAlertsConstants.gridFilterTypes.Agent];
      dataSorted = data.map(item => ({ ...item })).sort((a, b) => a[dataFieldName].localeCompare(b[dataFieldName], 'en'));

      if (!(gridFilterOptions[TeamAlertsConstants.gridFilterTypes.Agent].ascendingSortOrder)) {
        dataSorted = dataSorted.reverse();
      }

      setData(dataSorted);
    }
  }, [gridFilterOptions[TeamAlertsConstants.gridFilterTypes.Agent].ascendingSortOrder]);
  useEffect(() => {
    if (data.length) {
      let alertsData = data.map(item => ({ ...item }));
      alertsData = filterDataByFilterType(TeamAlertsConstants.gridFilterTypes.Agent, alertsData);
      alertsData = filterDataByFilterType(TeamAlertsConstants.gridFilterTypes.AlertType, alertsData);
      alertsData = filterDataByFilterType(TeamAlertsConstants.gridFilterTypes.TeamLead, alertsData);

      setFilteredData(alertsData);
    }
  }, [gridFilterOptions, data]);
  useEffect(() => {
    if (data.length) {
      const agentFilterOptions = { ...gridFilterOptions[TeamAlertsConstants.gridFilterTypes.Agent] }
      const TLFilterOptions = { ...gridFilterOptions[TeamAlertsConstants.gridFilterTypes.TeamLead] }
      const agentNameField = TeamAlertsConstants.filterHeaderToFieldMapping[TeamAlertsConstants.gridFilterTypes.Agent];
      const TLNameField = TeamAlertsConstants.filterHeaderToFieldMapping[TeamAlertsConstants.gridFilterTypes.TeamLead];
      const agentOptionsReplacement = [];
      const TLOptionsReplacement = [];
      const agents = agentFilterOptions.options.reduce(
          (obj, item) => ({
              ...obj,
              [item.title]: item,
              }),
          {}
      );

      const supervisors = TLFilterOptions.options.reduce(
          (obj, item) => ({
              ...obj,
              [item.title]: item,
              }),
          {}
      );

      data.map((alert) => {
        const agentName = alert[agentNameField];
        const TLName = alert[TLNameField];
        const agentOption = { title: agentName, isActive: false }
        const TLOption = { title: TLName, isActive: false }

        if (agents[agentName] && !(agentOptionsReplacement.map(option => option.title).includes(agentOption.title))) {
          const selectedOption = { title: agentName, isActive: agents[agentName].isActive }
          agentOptionsReplacement.push(selectedOption);
        }
        else if (!(agentOptionsReplacement.map(option => option.title).includes(agentOption.title))) {
          agentOptionsReplacement.push(agentOption);
        }

        if (supervisors[TLName] && !(TLOptionsReplacement.map(option => option.title).includes(TLOption.title))) {
          const selectedOption = { title: TLName, isActive: supervisors[TLName].isActive }
          TLOptionsReplacement.push(selectedOption);
        }
        else if (!(TLOptionsReplacement.map(option => option.title).includes(TLOption.title))) {
          TLOptionsReplacement.push(TLOption);
        }

        return null;
      });
      agentOptionsReplacement.sort((a, b) => a.title.localeCompare(b.title, 'en'));
      TLOptionsReplacement.sort((a, b) => a.title.localeCompare(b.title, 'en'));
      agentFilterOptions.options = agentOptionsReplacement;
      TLFilterOptions.options = TLOptionsReplacement;

      const originalFilters = { ...gridFilterOptions }
      originalFilters[TeamAlertsConstants.gridFilterTypes.Agent] = agentFilterOptions;
      originalFilters[TeamAlertsConstants.gridFilterTypes.TeamLead] = TLFilterOptions;

      setGridFilterOptions(originalFilters);
    }
  }, [data, selectedFilters]);

  const myTeamColumns = [
  { title: <ColumnFilter filterOptionsContext={gridFilterOptions} filterType={TeamAlertsConstants.gridFilterTypes.AlertType} columnTitle="Alert Type" />, field: 'AlertTypeDesc', sorting: false },
  { title: 'ID', field: 'EmployeeId' },
  { title: <ColumnFilter filterOptionsContext={gridFilterOptions} filterType={TeamAlertsConstants.gridFilterTypes.Agent} columnTitle="Agent" />, field: 'EmployeeData', sorting: false },
  { title: 'Client', field: 'Client' },
  { title: 'Program', field: 'Program' },
  { title: 'Project', field: 'Project' },
  { title: 'Site', field: 'Site' },
  { title: 'Start Time', field: 'UTCStartMomentTS', render: (rowData) => moment.utc(rowData.UTCStartMomentTS).local().format('M/D/YYYY HH:mm') },
  {
    title: 'Stop Time', field: 'UTCStopMomentTS', render: (rowData) => ((rowData.UTCStopMomentTS === null || rowData.UTCStopMomentTS === '') ? 'N/A' : moment.utc(rowData.UTCStopMomentTS).local().format('M/D/YYYY HH:mm')), customSort: (a, b) => (a.UTCStopMomentTS === b.UTCStopMomentTS ? 0 : !a.UTCStopMomentTS ? 1 : !b.UTCStopMomentTS ? -1 : a < b ? -1 : 1),
  },
  { title: 'Duration', field: 'Duration' },
  { title: 'Status', field: 'Status' },
  ];
  const otherTeamsColumns = [
    {
      title: <ColumnFilter filterOptionsContext={gridFilterOptions} filterType={TeamAlertsConstants.gridFilterTypes.TeamLead} columnTitle="Team Lead" />, field: 'SupervisorEmployeeData', sorting: false, cellStyle: () => ({ fontSize: '6px !important' }),
    },
    { title: <ColumnFilter filterOptionsContext={gridFilterOptions} filterType={TeamAlertsConstants.gridFilterTypes.AlertType} columnTitle="Alert Type" />, field: 'AlertTypeDesc', sorting: false },
    { title: 'ID', field: 'EmployeeId' },
    { title: <ColumnFilter filterOptionsContext={gridFilterOptions} filterType={TeamAlertsConstants.gridFilterTypes.Agent} columnTitle="Agent" />, field: 'EmployeeData', sorting: false },
    { title: 'Client', field: 'Client' },
    { title: 'Program', field: 'Program' },
    { title: 'Project', field: 'Project' },
    { title: 'Site', field: 'Site' },
    {
      title: 'Start Time', field: 'UTCStartMomentTS', render: (rowData) => moment.utc(rowData.UTCStartMomentTS).local().format('M/D/YYYY HH:mm'),
    },
    {
      title: 'Stop Time', field: 'UTCStopMomentTS', render: (rowData) => ((rowData.UTCStopMomentTS === null || rowData.UTCStopMomentTS === '') ? 'N/A' : moment.utc(rowData.UTCStopMomentTS).local().format('M/D/YYYY HH:mm')), customSort: (a, b) => (a.UTCStopMomentTS === b.UTCStopMomentTS ? 0 : !a.UTCStopMomentTS ? 1 : !b.UTCStopMomentTS ? -1 : a < b ? -1 : 1),
    },
    { title: 'Duration', field: 'Duration' },
    { title: 'Status', field: 'Status' },
  ];

  const gridConfigurations = {
    MY_TEAM: {
      keyGrid: 1,
      columns: myTeamColumns,
      options: TeamAlertsConstants.myTeamOptions,
      localization: TeamAlertsConstants.localization,
    },
    OTHER_TEAMS: {
      keyGrid: 2,
      columns: otherTeamsColumns,
      options: TeamAlertsConstants.otherTeamsOptions,
      localization: TeamAlertsConstants.localization
    }
  }

  const [gridConfiguration, setGridConfiguration] = useState(gridConfigurations.MY_TEAM);

  const [
    getSubscribedScheduleAlerts,
    {
      data: dataSubscribedScheduleAlerts,
      loading: loadingSubscribedScheduleAlerts,
      networkStatus: subscribedScheduleAlertsNetworkStatus
    }
  ] = useLazyQuery(Q.SUBSCRIBED_SCHEDULE_ALERT, { notifyOnNetworkStatusChange: true } );

  const [
    getSubscribedPerformanceAlerts,
    {
      data: dataSubscribedPerformanceAlerts,
      loading: loadingSubscribedPerformanceAlerts,
      networkStatus: subscribedPerformanceAlertsNetworkStatus
    }
  ] = useLazyQuery(Q.SUBSCRIBED_PERFORMANCE_ALERT, { notifyOnNetworkStatusChange: true });

  const [
    getScheduleAlertsMyTeamToday,
    {
      data: dataScheduleAlertsMyTeamToday,
      loading: loadingScheduleAlertsMyTeamToday,
      networkStatus: scheduleAlertsNetworkStatusMyTeamToday
    }
  ] = useLazyQuery(Q.ALERTS_SCHEDULE_TODAY_MY_TEAM, { notifyOnNetworkStatusChange: true });

  const [
    getScheduleAlertsMyTeamWeekly,
    {
      data: dataScheduleAlertsMyTeamWeekly,
      loading: loadingScheduleAlertsMyTeamWeekly,
      networkStatus: scheduleAlertsNetworkStatusMyTeamWeekly
    }
  ] = useLazyQuery(Q.ALERTS_SCHEDULE_WEEKLY_MY_TEAM, { notifyOnNetworkStatusChange: true });

  const [
    getScheduleAlertsMyTeamCustom,
    {
      data: dataScheduleAlertsMyTeamCustom,
      loading: loadingScheduleAlertsMyTeamCustom,
      networkStatus: scheduleAlertsNetworkStatusMyTeamCustom
    }
  ] = useLazyQuery(Q.ALERTS_SCHEDULE_CUSTOM_MY_TEAM, { notifyOnNetworkStatusChange: true });

  const [
    getScheduleAlertsOtherTeamsToday,
    {
      data: dataScheduleAlertsOtherTeamsToday,
      loading: loadingScheduleAlertsOtherTeamsToday,
      networkStatus: scheduleAlertsNetworkStatusOtherTeamsToday
    }
  ] = useLazyQuery(Q.ALERTS_SCHEDULE_TODAY_OTHER_TEAMS, { notifyOnNetworkStatusChange: true });

  const [
    getScheduleAlertsOtherTeamsWeekly,
    {
      data: dataScheduleAlertsOtherTeamsWeekly,
      loading: loadingScheduleAlertsOtherTeamsWeekly,
      networkStatus: scheduleAlertsNetworkStatusOtherTeamsWeekly
    }
  ] = useLazyQuery(Q.ALERTS_SCHEDULE_WEEKLY_OTHER_TEAMS, { notifyOnNetworkStatusChange: true });

  const [
    getScheduleAlertsOtherTeamsCustom,
    {
      data: dataScheduleAlertsOtherTeamsCustom,
      loading: loadingScheduleAlertsOtherTeamsCustom,
      networkStatus: scheduleAlertsNetworkStatusOtherTeamsCustom
    }
  ] = useLazyQuery(Q.ALERTS_SCHEDULE_CUSTOM_OTHER_TEAMS, { notifyOnNetworkStatusChange: true });

  const [
    getActivityAlertsMyTeamToday,
    {
      data: dataActivityAlertsMyTeamToday,
      loading: loadingActivityAlertsMyTeamToday,
      networkStatus: activityAlertsNetworkStatusMyTeamToday
    }
  ] = useLazyQuery(Q.ALERTS_ACTIVITY_TODAY_MY_TEAM, { notifyOnNetworkStatusChange: true });

  const [
    getActivityAlertsOtherTeamsToday,
    {
      data: dataActivityAlertsOtherTeamsToday,
      loading: loadingActivityAlertsOtherTeamsToday,
      networkStatus: activityAlertsNetworkStatusOtherTeamsToday
    }
  ] = useLazyQuery(Q.ALERTS_ACTIVITY_TODAY_OTHER_TEAMS, { notifyOnNetworkStatusChange: true });

  const getAlerts = (alert, lastKey=0, nextPage) => {
    clearAutoRefresh();

    if (selectedFilters.length) {
      if (alert === AlertType.schedule && selectedFilters[0] === MY_TEAM && selectedFilters[1] === TODAY) {
        getScheduleAlertsMyTeamToday({
          variables: {
            EmployeeId: parseInt(employeeId, 10),
              LastKey: lastKey, 
              NextPage: nextPage
          }
        });
      }
      else if (alert === AlertType.schedule && selectedFilters[0] === MY_TEAM && selectedFilters[1] === THIS_WEEK) {
        getScheduleAlertsMyTeamWeekly({
          variables: {
            EmployeeId: parseInt(employeeId, 10),
              LastKey: lastKey, 
              NextPage: nextPage
          }
        });
      }
      else if (alert === AlertType.schedule && selectedFilters[0] === MY_TEAM && selectedFilters[1] === CUSTOM) {
        getScheduleAlertsMyTeamCustom({
          variables: {
            EmployeeId: parseInt(employeeId, 10),
            CustomInit: selectedDateRangePicker[0],
            CustomEnd: selectedDateRangePicker[1],
              LastKey: lastKey, 
              NextPage: nextPage
          }
        });
      }
      else if (alert === AlertType.schedule && selectedFilters[0] === OTHER_TEAMS && selectedFilters[1] === TODAY) {
        getScheduleAlertsOtherTeamsToday({
          variables: {
            EmployeeId: parseInt(employeeId, 10),
              LastKey: lastKey, 
              NextPage: nextPage
          }
        });
      }
      else if (alert === AlertType.schedule && selectedFilters[0] === OTHER_TEAMS && selectedFilters[1] === THIS_WEEK) {
        getScheduleAlertsOtherTeamsWeekly({
          variables: {
            EmployeeId: parseInt(employeeId, 10),
              LastKey: lastKey, 
              NextPage: nextPage
          }
        });
      }
      else if (alert === AlertType.schedule && selectedFilters[0] === OTHER_TEAMS && selectedFilters[1] === CUSTOM) {
        getScheduleAlertsOtherTeamsCustom({
          variables: {
            EmployeeId: parseInt(employeeId, 10),
            CustomInit: selectedDateRangePicker[0],
            CustomEnd: selectedDateRangePicker[1],
              LastKey: lastKey, 
              NextPage: nextPage
          }
        });
      }
      else if (alert === AlertType.performance && selectedFilters[0] === MY_TEAM && selectedFilters[1] === TODAY) {
        getActivityAlertsMyTeamToday({
          variables: {
            EmployeeId: parseInt(employeeId, 10),
              LastKey: lastKey, 
              NextPage: nextPage
          }
        });
      }
      else if (alert === AlertType.performance && selectedFilters[0] === OTHER_TEAMS && selectedFilters[1] === TODAY) {
        getActivityAlertsOtherTeamsToday({
          variables: {
            EmployeeId: parseInt(employeeId, 10),
              LastKey: lastKey, 
              NextPage: nextPage
          }
        });
      }
    }
    else if (selectedAlertType === AlertType.schedule) {
      getSubscribedScheduleAlerts({
        variables: {
          ClientId: selectedCPPS.client ? selectedCPPS.client.ClientId.toString() : null,
          ProgramId: selectedCPPS.program ? selectedCPPS.program.ProgramId.toString() : null,
          ProjectId: selectedCPPS.project ? selectedCPPS.project.ProjectId.toString() : null,
          SiteId: selectedCPPS.site ? selectedCPPS.site.SiteId.toString(): null,
          AgentEmployeeId: selectedCPPS.agentEmployeeId,
          AgentEmployeeName: selectedCPPS.agentEmployeeName,
          SupervisorEmployeeId: selectedCPPS.supervisorEmployeeId,
          LastKey: lastKey, 
          NextPage: nextPage
        }
      });
    }
    else if (selectedAlertType === AlertType.performance) {
      getSubscribedPerformanceAlerts({
        variables: {
          ClientId: selectedCPPS.client ? selectedCPPS.client.ClientId.toString() : null,
          ProgramId: selectedCPPS.program ? selectedCPPS.program.ProgramId.toString() : null,
          ProjectId: selectedCPPS.project ? selectedCPPS.project.ProjectId.toString() : null,
          SiteId: selectedCPPS.site ? selectedCPPS.site.SiteId.toString(): null,
          AgentEmployeeId: selectedCPPS.agentEmployeeId,
          AgentEmployeeName: selectedCPPS.agentEmployeeName,
          SupervisorEmployeeId: selectedCPPS.supervisorEmployeeId,
          LastKey: lastKey, 
          NextPage: nextPage
        }
      });
    }
  }

  const onChangePage = (e, newPage) => {
    // debugger
    let lastRow = Math.min(...filteredData.map(item => item.rowNumber));
    let next = nextPage;

    if (currentPage > newPage) {
      // TODO:
      // Check why previous page does not take the minor number
      setNextPage(false);
      lastRow = Math.max(...filteredData.map(item => item.rowNumber));
      next = false;
    }
    else {
      next = true;
      setNextPage(true);
    }
    setCurrentPage(newPage);
    setLastKey(lastRow);
    getAlerts(selectedAlertType, lastRow, next);
  }

  const onChangeFilter = (_filters) => {
    setSelectedFilters(_filters);
    setData([]);
    setFilteredData([]);
    clearPagination();
}

  const onClearClick = () => {
    clearAutoRefresh();
    setData([]);
    setSelectedCPPS({ client: null, program: null, project: null, site: null, agentEmployeeId: null, agentEmployeeName: null, supervisorEmployeeId: null });
  }

  const onSearchClick = (client, program, project, site, agentEmployeeId, agentEmployeeName, supervisorEmployeeId) => {
    clearAutoRefresh();

    setSelectedFilters([]);
    setSelectedCPPS({ 
      client: client ?? null, 
      program: program ?? null, 
      project: project ?? null, 
      site: site ?? null, 
      agentEmployeeId: agentEmployeeId ?? null,
      agentEmployeeName: agentEmployeeName ?? null, 
      supervisorEmployeeId: supervisorEmployeeId ?? null 
    });

    if (selectedAlertType === AlertType.schedule) {
      getSubscribedScheduleAlerts({
        variables: {
          ClientId: client ? client.ClientId.toString() : null,
          ProgramId: program ? program.ProgramId.toString() : null,
          ProjectId: project ? project.ProjectId.toString() : 'All',
          SiteId: site ? site.SiteId.toString() : 'All',
          AgentEmployeeId: agentEmployeeId,
          AgentEmployeeName: agentEmployeeName,
          SupervisorEmployeeId: supervisorEmployeeId,
          LastKey: lastKey, 
          NextPage: nextPage
        }
      });
    }
    
    if (selectedAlertType === AlertType.performance) {
      getSubscribedPerformanceAlerts({
        variables: {
          ClientId: client ? client.ClientId.toString() : null,
          ProgramId: program ? program.ProgramId.toString() : null,
          ProjectId: project ? project.ProjectId.toString() : null,
          SiteId: site ? site.SiteId.toString() : null,
          AgentEmployeeId: agentEmployeeId,
          AgentEmployeeName: agentEmployeeName,
          SupervisorEmployeeId: supervisorEmployeeId,
          LastKey: lastKey, 
          NextPage: nextPage
        }
      });
    }
  }

  const handleDateRangePicker = async (startDate, finishDate) => {
    dispatch(setSelectedDateRangePicker([startDate, finishDate]));
  }

  const handleAlertTypes = checked => {
    setAlertType(checked);
    if (checked) dispatch(setSelectedAlertType(AlertType.performance))
    else dispatch(setSelectedAlertType(AlertType.schedule))
  }

  const alertDataManager = (alertData, networkStatus) => {
    if (alertData && networkStatus === NetworkStatus.ready) {
      clearAutoRefresh();
      toastId.current = showRefreshNotification(TeamAlertsConstants.refreshFrequencySeconds);

      setData(alertData);

      const timeoutId = setTimeout(() => {
        getAlerts(selectedAlertType, lastKey, nextPage);
      }, TeamAlertsConstants.refreshFrequency);

      setLatestTimeoutId(timeoutId);
    }
  }

  useEffect(() => {
    if (dataSubscribedScheduleAlerts && subscribedScheduleAlertsNetworkStatus === NetworkStatus.ready) {
        clearAutoRefresh();

      if (!(dataSubscribedScheduleAlerts.searchScheduleAlertsForSubscriptions)
        || !(dataSubscribedScheduleAlerts.searchScheduleAlertsForSubscriptions.data.length)) {
        toast(transactionResponse(null, null, TeamAlertsConstants.transactionMessages.CPPSNotFound));
      }
      else {
        toastId.current = showRefreshNotification(TeamAlertsConstants.refreshFrequencySeconds);
        setTotalPages(dataSubscribedScheduleAlerts.searchScheduleAlertsForSubscriptions.count);

        if (gridTitle !== TeamAlertsConstants.gridTitles.YourSearch) {
          setGridTitle(TeamAlertsConstants.gridTitles.YourSearch);
        }

        if (gridConfiguration !== gridConfigurations[OTHER_TEAMS]) {
          setGridConfiguration(gridConfigurations[OTHER_TEAMS]);
        }

        setData(dataSubscribedScheduleAlerts.searchScheduleAlertsForSubscriptions.data);
        const timeoutId = setTimeout(() => {
          getSubscribedScheduleAlerts({
            variables: {
              ClientId: selectedCPPS.client ? selectedCPPS.client.ClientId.toString() : null,
              ProgramId: selectedCPPS.program ? selectedCPPS.program.ProgramId.toString() : null,
              ProjectId: selectedCPPS.project ? selectedCPPS.project.ProjectId.toString() : null,
              SiteId: selectedCPPS.site ? selectedCPPS.site.SiteId.toString(): null,
              AgentEmployeeId: selectedCPPS.agentEmployeeId,
              AgentEmployeeName: selectedCPPS.agentEmployeeName,
              SupervisorEmployeeId: selectedCPPS.supervisorEmployeeId,
              LastKey: lastKey, 
              NextPage: nextPage
            }
          });
        }, TeamAlertsConstants.refreshFrequency
        );
        setLatestTimeoutId(timeoutId);
      }
    }
  }, [dataSubscribedScheduleAlerts, subscribedScheduleAlertsNetworkStatus]);

  useEffect(() => {
    if (dataSubscribedPerformanceAlerts && subscribedPerformanceAlertsNetworkStatus === NetworkStatus.ready) {
      clearAutoRefresh();

      if (!(dataSubscribedPerformanceAlerts.searchPerformanceAlertsForSubscriptions)
        || !(dataSubscribedPerformanceAlerts.searchPerformanceAlertsForSubscriptions.data.length)) {
        toastId.current = toast(transactionResponse(null, null, TeamAlertsConstants.transactionMessages.CPPSNotFound));
      }
      else {
        toastId.current = showRefreshNotification(TeamAlertsConstants.refreshFrequencySeconds);
        setTotalPages(dataSubscribedPerformanceAlerts.searchPerformanceAlertsForSubscriptions.count);

        if (gridTitle !== TeamAlertsConstants.gridTitles.YourSearch) {
          setGridTitle(TeamAlertsConstants.gridTitles.YourSearch);
        }

        if (gridConfiguration !== gridConfigurations[OTHER_TEAMS]) {
          setGridConfiguration(gridConfigurations[OTHER_TEAMS]);
        }

        setData(dataSubscribedPerformanceAlerts.searchPerformanceAlertsForSubscriptions.data);
        const timeoutId = setTimeout(() => {
          getSubscribedPerformanceAlerts({
            variables: {
              ClientId: selectedCPPS.client.ClientId.toString(),
              ProgramId: selectedCPPS.program.ProgramId.toString(),
              ProjectId: selectedCPPS.project.ProjectId.toString(),
              SiteId: selectedCPPS.site.SiteId.toString(),
              AgentEmployeeId: selectedCPPS.agentEmployeeId,
              AgentEmployeeName: selectedCPPS.agentEmployeeName,
              SupervisorEmployeeId: selectedCPPS.supervisorEmployeeId,
              LastKey: lastKey, 
              NextPage: nextPage
            }
          });
        }, TeamAlertsConstants.refreshFrequency);
        setLatestTimeoutId(timeoutId);
      }
    }
  }, [dataSubscribedPerformanceAlerts, subscribedPerformanceAlertsNetworkStatus]);

  useEffect(() => {
    if (dataScheduleAlertsMyTeamToday?.todayScheduleForMyTeam.data.length) {
      setTotalPages(dataScheduleAlertsMyTeamToday.todayScheduleForMyTeam.count);
      setGridTitle(TeamAlertsConstants.gridTitles.MyTeamsAlerts);
      if (gridConfiguration !== gridConfigurations[MY_TEAM]) {
        setGridConfiguration(gridConfigurations[MY_TEAM]);
      }
      alertDataManager(dataScheduleAlertsMyTeamToday.todayScheduleForMyTeam.data, scheduleAlertsNetworkStatusMyTeamToday);
    }
  }, [dataScheduleAlertsMyTeamToday, scheduleAlertsNetworkStatusMyTeamToday]);

  useEffect(() => {
    if (dataScheduleAlertsMyTeamWeekly?.thisWeekScheduleForMyTeam.data.length) {
      setTotalPages(dataScheduleAlertsMyTeamWeekly.thisWeekScheduleForMyTeam.count);
      setGridTitle(TeamAlertsConstants.gridTitles.MyTeamsAlerts);
      if (gridConfiguration !== gridConfigurations[MY_TEAM]) {
        setGridConfiguration(gridConfigurations[MY_TEAM]);
      }
      alertDataManager(dataScheduleAlertsMyTeamWeekly.thisWeekScheduleForMyTeam.data, scheduleAlertsNetworkStatusMyTeamWeekly);
    }
  }, [dataScheduleAlertsMyTeamWeekly, scheduleAlertsNetworkStatusMyTeamWeekly]);

  useEffect(() => {
    if (dataScheduleAlertsMyTeamCustom?.customScheduleForMyTeam.data.length) {
      setTotalPages(dataScheduleAlertsMyTeamCustom.customScheduleForMyTeam.count);
      setGridTitle(TeamAlertsConstants.gridTitles.MyTeamsAlerts);
      if (gridConfiguration !== gridConfigurations[MY_TEAM]) {
        setGridConfiguration(gridConfigurations[MY_TEAM]);
      }
      alertDataManager(dataScheduleAlertsMyTeamCustom.customScheduleForMyTeam.data, scheduleAlertsNetworkStatusMyTeamCustom);
    }
  }, [dataScheduleAlertsMyTeamCustom, scheduleAlertsNetworkStatusMyTeamCustom]);

  useEffect(() => {
    if (dataScheduleAlertsOtherTeamsToday?.todayScheduleForOtherTeams.data.length) {
      setTotalPages(dataScheduleAlertsOtherTeamsToday.todayScheduleForOtherTeams.count);
      setGridTitle(TeamAlertsConstants.gridTitles.OtherTeamsAlerts);
      setGridConfiguration(gridConfigurations[OTHER_TEAMS]);
      alertDataManager(dataScheduleAlertsOtherTeamsToday.todayScheduleForOtherTeams.data, scheduleAlertsNetworkStatusOtherTeamsToday);
    }
  }, [dataScheduleAlertsOtherTeamsToday, scheduleAlertsNetworkStatusOtherTeamsToday]);

  useEffect(() => {
    if (dataScheduleAlertsOtherTeamsWeekly?.thisWeekScheduleForOtherTeams.data.length) {
      setTotalPages(dataScheduleAlertsOtherTeamsWeekly.thisWeekScheduleForOtherTeams.count);
      setGridTitle(TeamAlertsConstants.gridTitles.OtherTeamsAlerts);
      setGridConfiguration(gridConfigurations[OTHER_TEAMS]);
      alertDataManager(dataScheduleAlertsOtherTeamsWeekly.thisWeekScheduleForOtherTeams.data, scheduleAlertsNetworkStatusOtherTeamsWeekly);
    }
  }, [dataScheduleAlertsOtherTeamsWeekly, scheduleAlertsNetworkStatusOtherTeamsWeekly]);

  useEffect(() => {
    if (dataScheduleAlertsOtherTeamsCustom?.customScheduleForOtherTeams.data.length) {
      setTotalPages(dataScheduleAlertsOtherTeamsCustom.customScheduleForOtherTeams.count);
      setGridTitle(TeamAlertsConstants.gridTitles.OtherTeamsAlerts);
      setGridConfiguration(gridConfigurations[OTHER_TEAMS]);
      alertDataManager(dataScheduleAlertsOtherTeamsCustom.customScheduleForOtherTeams.data, scheduleAlertsNetworkStatusOtherTeamsCustom);
    }
  }, [dataScheduleAlertsOtherTeamsCustom, scheduleAlertsNetworkStatusOtherTeamsCustom]);

  useEffect(() => {
    if (dataActivityAlertsMyTeamToday?.todayActivityForMyTeam.data.length) {
      setTotalPages(dataActivityAlertsMyTeamToday.todayActivityForMyTeam.count);
      setGridTitle(TeamAlertsConstants.gridTitles.MyTeamsAlerts);
      if (gridConfiguration !== gridConfigurations[MY_TEAM]) {
        setGridConfiguration(gridConfigurations[MY_TEAM]);
      }
      alertDataManager(dataActivityAlertsMyTeamToday.todayActivityForMyTeam.data, activityAlertsNetworkStatusMyTeamToday);
    }
  }, [dataActivityAlertsMyTeamToday, activityAlertsNetworkStatusMyTeamToday]);

  useEffect(() => {
    if (dataActivityAlertsOtherTeamsToday?.todayActivityForOtherTeams.data.length) {
      setTotalPages(dataActivityAlertsOtherTeamsToday.todayActivityForOtherTeams.count);
      setGridTitle(TeamAlertsConstants.gridTitles.OtherTeamsAlerts);
      setGridConfiguration(gridConfigurations[OTHER_TEAMS]);
      alertDataManager(dataActivityAlertsOtherTeamsToday.todayActivityForOtherTeams.data, activityAlertsNetworkStatusOtherTeamsToday);
    }
  }, [dataActivityAlertsOtherTeamsToday, activityAlertsNetworkStatusOtherTeamsToday]);

  useEffect(() => {
    getAlerts(selectedAlertType, null, true);
  }, [selectedFilters, selectedDateRangePicker]);

  useEffect(() => {
    if (selectedAlertType === AlertType.schedule) {
      setAlertType(false);
    }
    else {
      setAlertType(true);
    }
    setCurrentPage(0);
    setTotalPages(0);
    getAlerts(selectedAlertType, null, true);
    setFilteredData([]);
    setData([]);
  }, [selectedAlertType, user]);

  return (
    <Box className='__teamAlerts'>
      <div className='__teamAlerts__filters'>
        <Filters
          onChange={onChangeFilter}
          selectedFilters={selectedFilters}
        />
        <Search onSearchClick={onSearchClick} onClear={onClearClick} showAgentAccordion />
      </div>
      <div className='__teamAlerts__grid'>
        <Box className='__teamAlerts__grid--container'>
          <Box className='__teamAlerts__grid--container-title'>
            <span>
              {gridTitle}
            </span>
            {selectedFilters && selectedFilters.includes(CUSTOM)
              && (
                <span
                  className='__teamAlerts__grid--container-dateRange'
                >
                  <p className='__teamAlerts__grid--container-dateRange-title'>Date: </p>
                  <CalloutBasic
                    dateRange={selectedDateRangePicker}
                    handleDateRangePicker={handleDateRangePicker}
                  />
                </span>
              )}
          </Box>
          <div className='__teamAlerts__grid--switch-container'>
            <span className='__teamAlerts__grid--switch-title'>Alert Type</span>
            <SwitchCustom
              options={TeamAlertsConstants.switchOptions}
              handleSwitch={handleAlertTypes}
              switchStatus={alertType}
              isDualOption
            />
          </div>
        </Box>
        <TeamAlertsGrid
          keyGrid={gridConfiguration.keyGrid}
          columns={gridConfiguration.columns}
          actions={gridConfiguration.actions}
          options={gridConfiguration.options}
          localization={gridConfiguration.localization}
          components={ 
            { 
              Pagination: (props) => 
                <TablePagination 
                // eslint-disable-next-line react/jsx-props-no-spreading
                  {...props} 
                  page={currentPage}
                  onPageChange={onChangePage}  
                  count={totalPages}
                  rowsPerPage={filteredData.length <= 15 ? 15 : filteredData.length}
                />
            } 
          }
          data={filteredData.map((o) => ({ ...o }))}
          isLoading={
            loadingSubscribedScheduleAlerts || loadingSubscribedPerformanceAlerts || loadingScheduleAlertsOtherTeamsWeekly || 
            loadingScheduleAlertsOtherTeamsCustom || loadingActivityAlertsMyTeamToday || loadingActivityAlertsOtherTeamsToday || 
            loadingScheduleAlertsMyTeamToday || loadingScheduleAlertsMyTeamWeekly || loadingScheduleAlertsMyTeamCustom || loadingScheduleAlertsOtherTeamsToday
      }
        />
      </div>
      <ToastContainer hideProgressBar />
    </Box>
  );
}

const TeamAlertsWithContext = () => <TeamAlertsContextProvider><TeamAlertsSearch /></TeamAlertsContextProvider>;

export default TeamAlertsWithContext;
